<form class="report-filters" [formGroup]="form">
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="startDate" [placeholder]="'Start Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="endDate" [placeholder]="'End Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="status" [showClear]="true" [options]="policyStatuses"
                placeholder="Policy status"></p-dropdown>
        </span>
    </div>
    <div class="controls-wrapper" *ngIf="canFilterByUser">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="userId" [showClear]="true" [options]="users"
                placeholder="Choose user"></p-dropdown>
        </span>
    </div>
    <div class="controls-wrapper button-wrapper">
        <p-button label="Search" [text]="true" [raised]="true" severity="success" [disabled]="form.invalid"
            (onClick)="submit()" class="report-action-button" icon="pi pi-search"></p-button>
        <p-button label="Export" [text]="true" [raised]="true" (onClick)="export()"
            severity="success" class="report-action-button" icon="pi pi-download"></p-button>
    </div>
</form>
<hr />
<div class="table-container">
    <p-table #reportTable [value]="reports" [scrollable]="true"
        scrollHeight="400px" styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }"
        responsiveLayout="stack" [breakpoint]="'768px'">
        <ng-template pTemplate="header">
            <tr>
                <th>Date</th>
                <th>Customer Name</th>
                <th>Customer Mobile</th>
                <th>Policy Number</th>
                <th>Policy Status</th>
                <th>Payment Status</th>
                <th>Payment Frequency</th>
                <th>Total Amount</th>
                <th>Dependant Count</th>
                <th>Currency</th>
                <th>Payment Method</th>
                <th>NOK Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Date</span>
                    {{ report["dateCreated"] ? (report["dateCreated"] | date : "dd/MM/yyyy") : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Customer Name</span>
                    {{ report.customer ? report.customer.firstName + " " + report.customer.lastName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Customer Mobile</span>
                    {{ report["customer"] ? report["customer"]["mobileNumber"]["countryCode"] + report["customer"]["mobileNumber"]["phoneNumber"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Number</span>
                    {{ report.policyNumber ? report.policyNumber : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Status</span>
                    {{ report.policyStatus ? report.policyStatus : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Payment Status</span>
                    {{ report.paymentStatus ? report.paymentStatus : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Payment Frequency</span>
                    {{ report.premiumFrequency ? report.premiumFrequency : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Total Amount</span>
                    {{ report.totalAmount ? report.totalAmount : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Dependant Count</span>
                    {{ report.dependantCount ? report.dependantCount : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Currency</span>
                    {{ report.currency ? report.currency.code : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Payment Method</span>
                    {{ report.paymentMethod ? report.paymentMethod : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">NOK Name</span>
                    {{ report.nokName ? report.nokName : "---" }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
